import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// Components
import { CatalogUpload } from '@mobilitystore/components-interface';
import CustomizedSnackbars from '../../../components/Shared/Utils/SnackBar';
import Loader from '../../../components/Shared/Utils/Loader';

// Actions
import { regenerateAAATokens } from '../../../actions/LoginAction';
import { getCompanyRegistrationDetails } from '../../../actions/user-service-action';

// Constants
import idConstants from '../../../data/idConstants';
import { AAA_CONFIG } from '../../../actions/configuration';

// Utils
import { getEnvironment } from '../../../utils';
import isEmpty from '../../../validator/isEmpty';

// CSS
import './index.scss';

const BulkProductUploadContainer = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { userCompanyStatus, companyRegistrationDetails } = useSelector((state) => {
    return {
      userCompanyStatus: state.CompanyDetailsReducer.userCompanyStatus,
      companyRegistrationDetails:
        state.UserServiceReducer?.companyRegistrationDetails
    };
  });
  const initialSnackbarState = {
    status: '',
    show: false
  };
  const [snackbarStatus, setSnackbarStatus] = React.useState(initialSnackbarState);

  const isInitialCall = useRef(false);

  useEffect(() => {
    if (
      userCompanyStatus?.companyId &&
      isEmpty(companyRegistrationDetails) &&
      !isInitialCall.current
    ) {
      isInitialCall.current = true;
      dispatch(
        getCompanyRegistrationDetails(
          AAA_CONFIG.SELLER_ROLE,
          userCompanyStatus.companyId
        )
      );
    }
  }, [userCompanyStatus, companyRegistrationDetails]);

  const handleBulkProductUploadSuccess = (message) => {
    setSnackbarStatus({
      status: 'success',
      message: message,
      show: true
    });

    setTimeout(() => {
      history.push('/dashboard/bulk-product/history');
    }, 500);
  };

  const handleBulkProductUploadError = (error) => {
    setSnackbarStatus({
      status: 'error',
      message: error.message,
      show: true
    });

    if (error.error === 'ERR_NETWORK') {
      dispatch(regenerateAAATokens()).then(() => {
        window.location.reload();
      });
    }
  };

  return (
    <div>
      {snackbarStatus.show && (
        <CustomizedSnackbars
          severity={snackbarStatus.status}
          message={snackbarStatus.message}
          changeState={() => setSnackbarStatus(initialSnackbarState)}
        />
      )}
      {companyRegistrationDetails?.companyName ? (
        <CatalogUpload
          className='bulk-product-upload'
          token={localStorage.getItem(idConstants.tokens.aaaIdToken)}
          environment={getEnvironment(process.env.REACT_APP_ENVIRONMENT)}
          tenantId={process.env.REACT_APP_SELLER_TENANT_ID}
          providerName={companyRegistrationDetails?.companyName}
          onError={handleBulkProductUploadError}
          onCancel={() => history.goBack()}
          onSuccess={handleBulkProductUploadSuccess}
          isSeller
          isBulkOnboarding
        />
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default BulkProductUploadContainer;
